import { render, staticRenderFns } from "./GLYF_User_Data.vue?vue&type=template&id=31066e74&scoped=true"
import script from "./GLYF_User_Data.vue?vue&type=script&lang=js"
export * from "./GLYF_User_Data.vue?vue&type=script&lang=js"
import style0 from "./GLYF_User_Data.vue?vue&type=style&index=0&id=31066e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31066e74",
  null
  
)

export default component.exports